/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Session_MissingInputs */



/**
* | output |
* | --- |
* | "This practice conversation no longer exists, or it is not yours." |
*
* @param {Practice_Session_MissingInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_session_missing = /** @type {((inputs?: Practice_Session_MissingInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Session_MissingInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Dit oefengesprek bestaat niet meer, of het hoort niet bij jou.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cet entretien d'entraînement n'existe plus, ou il n'est pas le vôtre.")
	return /** @type {LocalizedString} */ ("This practice conversation no longer exists, or it is not yours.")
});